import { FileService } from "./file.service";
import _ from "lodash";
const excludeCloneFileTypes = ['G-SHEET'];
export default class AssetService {
  static canClone(asset) {
    if(!asset){
      return false;
    }
    const share = _.get(asset, 'settings.share');
    if(!share){
      return false;
    }

    var fileType = FileService.getFileType(asset.metadata);
    if(excludeCloneFileTypes.includes(fileType)){
      return false;
    } 
    
    return true;
  }
}